export { default as InfoModal } from "./InfoModal";
export { default as DeleteModal } from "./DeleteModal";
export { default as AddOperator } from "./AddOperator";
export { default as UpdateOperator } from "./UpdateOperator";
export { default as AddArticle } from "./AddArticle";
export { default as CreateCategory } from "./CreateCategory";
export { default as DraftArticle } from "./DraftArticle";
export { default as ConfirmSend } from "./ConfirmSendModal";
export { default as CreateBotQuestion } from "./CreateBotQuestion";
